import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Form, useNavigation } from 'react-router-dom';

const NewUserSlideIn = ({ showSlideIn, setShowSlideIn, onSubmit }) => {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    onSubmit(formData);
  };
  return (
    <Transition.Root show={showSlideIn} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setShowSlideIn}>
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <form
                    onSubmit={handleSubmit}
                    className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl"
                  >
                    <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                            Neuen Benutzer erstellen
                          </Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-hidden focus:ring-2 focus:ring-svisit-primary-500"
                              onClick={() => setShowSlideIn(false)}
                            >
                              <span className="absolute -inset-2.5" />
                              <span className="sr-only">Close panel</span>
                              <XMarkIcon
                                className="h-6 w-6"
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 flex-1 px-4 sm:px-6">
                        {/* Neuer Benutzer Start */}
                        <div className="flex h-full flex-col">
                          <div className="space-y-6 pb-5 pt-6">
                            <div>
                              <label
                                htmlFor="firstName"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Vorname
                              </label>
                              <div className="mt-2">
                                <input
                                  type="text"
                                  name="firstName"
                                  id="firstName"
                                  required
                                  className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="space-y-6 pb-5">
                            <div>
                              <label
                                htmlFor="lastName"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Nachname
                              </label>
                              <div className="mt-2">
                                <input
                                  type="text"
                                  name="lastName"
                                  id="lastName"
                                  required
                                  className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="space-y-6 pb-5">
                            <div>
                              <label
                                htmlFor="email"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                E-Mail
                              </label>
                              <div className="mt-2">
                                <input
                                  type="email"
                                  name="email"
                                  id="email"
                                  required
                                  className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="space-y-6 pb-5">
                            <div>
                              <label
                                htmlFor="password"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Passwort
                              </label>
                              <div className="mt-2">
                                <input
                                  type="password"
                                  name="password"
                                  id="password"
                                  required
                                  className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="space-y-6 pb-5">
                            <div>
                              <label
                                htmlFor="suppressEmail"
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                E-Mail Bestätigungsmail unterdrücken?
                              </label>
                              <div className="relative flex items-start">
                                <div className="mt-2">
                                  <input
                                    type="checkbox"
                                    name="suppressEmail"
                                    id="suppressEmail"
                                    className="h-4 w-4 rounded-sm border-gray-300 text-svisit-primary-600 focus:ring-svisit-primary-600"
                                  />
                                </div>
                                <div className="ml-3 text-sm leading-6">
                                  <p className="font-medium text-gray-900">
                                    Ja
                                  </p>
                                  <p className="text-gray-500">
                                    Wenn aktiviert, geht keine Bestätigungsmail
                                    an den Kontakt raus.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex shrink-0 justify-end px-4 py-4">
                      <button
                        type="button"
                        className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
                        onClick={() => setShowSlideIn(false)}
                      >
                        Abbrechen
                      </button>
                      <button
                        type="submit"
                        className="ml-4 inline-flex justify-center rounded-md bg-svisit-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-svisit-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-500 disabled:bg-gray-300 disabled:cursor-not-allowed"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Speichert...' : 'Speichern'}
                      </button>
                    </div>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default NewUserSlideIn;
